<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import process1 from './process-1.vue'

export default {
  page: {
    title: "Reports",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    process1
  },
  data() {
    return {
      pagetitle: "Звіти"
    };
  },
  created(){
   
  },
  computed :{
   
  },
  methods: {
   
  }
};
</script>

<template>
  <Layout :pagetitle="pagetitle" :is-busy="false">
    <div class="row">
      <div class="col">
        <process1>

          
        </process1>
      </div>
    </div>
  </Layout>
</template>
